import { render, staticRenderFns } from "./FeedbackCollapse.vue?vue&type=template&id=45a05def&scoped=true"
import script from "./FeedbackCollapse.vue?vue&type=script&lang=ts"
export * from "./FeedbackCollapse.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackCollapse.vue?vue&type=style&index=0&id=45a05def&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a05def",
  null
  
)

export default component.exports